export const SETTINGS_LIMITED_ROUTE = 'SettingsLimited';

export const RESTRICTED_ROOT_ROUTES = ['OnHold', 'Deactivated', SETTINGS_LIMITED_ROUTE, 'OnboardingWizard'] as const;

export type RestrictedRootRoute = (typeof RESTRICTED_ROOT_ROUTES)[number];

export const RESTRICTED_SIDEBAR_TABS = ['Users', 'Connector', 'Company', 'Support'] as const;

export type RestrictedSidebarTab = (typeof RESTRICTED_SIDEBAR_TABS)[number];

export enum TenantReason {
  OnHold = 'tenantActivationOnHold',
  Deactivated = 'tenantDeactivated',
}

export enum TenantStatusResult {
  OnHold = 'onHold',
  OnHoldWizard = 'onHold-wizard',
  Deactivated = 'deactivated',
  Unknown = 'unknown',
}

export const TENANT_REASON_TO_ROUTE = {
  [TenantStatusResult.OnHold]: 'OnHold',
  [TenantStatusResult.OnHoldWizard]: 'OnboardingWizard',
  [TenantStatusResult.Deactivated]: 'Deactivated',
} as const satisfies Partial<Record<TenantStatusResult, RestrictedRootRoute>>;
